import Vue from 'vue'
import Vuex from 'vuex'

import configTreeMenuList from '../data/menu'

Vue.use(Vuex)

const store = new Vuex.Store({

  state: {

    treeMenuList: configTreeMenuList,
    lineMenuList: getLineMenuList(configTreeMenuList, [], ''),

    userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
    roleList: JSON.parse(sessionStorage.getItem('roleList')),

    token: sessionStorage.getItem('token'),
    ttlMillis: sessionStorage.getItem('ttlMillis'),

    isCollapse: false,
    asideWidth: '180px',

    openId: sessionStorage.getItem('openId'),
    // openId:"oJYNR5m3smKVjDyprSNVoGl54t6M",
    wxMpOAuth2AccessToken: JSON.parse(sessionStorage.getItem('wxMpOAuth2AccessToken')),
    wxMpUser: JSON.parse(sessionStorage.getItem('wxMpUser')),
    // jsApiSignature: JSON.parse(sessionStorage.getItem("jsApiSignature")),

    landRows: [
      /* {
        type: [],
        threshold: 0,
      } */
    ]
  }

})

function getLineMenuList (treeMenuList, lineMenuList, parentUri) {
  treeMenuList.forEach((item, index) => {
    lineMenuList.push(item)
    if (item.children) {
      getLineMenuList(item.children, lineMenuList, item.uri)
    }
  })
  return lineMenuList
}

export default store
